import { Link, useLocation } from 'react-router-dom';

// Catch-all 404. Used instead of a silent <Navigate to="/dashboard"> so that
// when a developer introduces a broken URL (typo, missed migration, etc.) the
// symptom is visible — landing on /dashboard after clicking a row would
// otherwise look like a feature, not a bug.
export default function NotFound() {
  const location = useLocation();
  return (
    <main className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-lg shadow p-6 text-center space-y-3">
        <h1 className="text-xl font-semibold">Page not found</h1>
        <p className="text-sm text-gray-600">
          No route matches <code className="px-1 bg-gray-100 rounded">{location.pathname}</code>.
        </p>
        <Link to="/dashboard" className="inline-block rounded bg-black text-white px-3 py-1 text-sm">
          Go to dashboard
        </Link>
      </div>
    </main>
  );
}
